export const INITIALIZE_HOME_PAGE = 'initialize-home-page';
const initializeHomePage = () => ({ type: INITIALIZE_HOME_PAGE });
export default initializeHomePage;
